import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosSetup";
import axios, { AxiosError } from "axios";
import queryString from "query-string";
import { AccountStatus } from "../../../constants/userStatus";

export const getAllUserDetailsByUser = createAsyncThunk(
  "/getAllUserDetails",
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
        `api/user-management/v1/users/getAllUserDetailsByUser?partnerId=` +
          payload.partnerId +
          `&userId=` +
          payload.usrId
        //`api/user-management/v1/users/getAllUserDetailsByUser?partnerId=56&userId=3`,
      );
      return {
        userData: {
          next: null,
          previous: null,
          list: response.data.userData.map((v: any) => ({
            ...v,
            mstPartnerId: v.mstPartnerId,
            mstUsrId: v.mstUsrId,
            loginId: v.loginId,
            usrNm: v.usrNm,
            contactNo: v.contactNo,
            title: v.title,
            contactPerson: v.contactPerson,
            partnerNm: v?.partnerNm,
            mstGrp: (v.mstGrp ?? []).map((g: any) => {
              return {
                mstGrpId: g.mstGrpId,
                usrGrpNm: g.usrGrpNm,
                locationAccess: g.locationAccess,
                countryAccess: g.countryAccess,
              };
            }),
            grpNm: v.mstGrp?.map((v: any) => v.usrGrpNm).join(","),
            status: v.status,
            countryShortCode: v.countryShortCode,
            countryName: v.countryName,
            isRootUser: v.isRootUser,
            countryAccess: v.countryAccess,
            locationAccess: v.mstGrp?.[0]?.locationAccess ?? v.locationAccess ?? "",
          })),
        },
        mstPartnerId: response.data.mstPartnerId,
        grpNm: "",
        mstUsrId: response.data.mstUsrId,
        loginId: response.data.loginId,
        usrNm: response.data.usrNm,
        contactNo: response.data.contactNo,
        title: response.data.title,
        contactPerson: response.data.contactPerson,

        status: response.data.status,
        countryShortCode: response.data.countryShortCode,
        countryName: response.data.countryName,
        isRootUser: response.data.isRootUser,
        partnerNm: response?.data?.partnerNm,
      };
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return {
        next: null,
        previous: null,
        list: [],
      };
    }
  }
);
export const getGroupListRegistrationMasterOPC = createAsyncThunk(
  "/getGroupListOPC",
  async (payload: any) => {
    //  debugger
    try {
      const response = await axiosInstance({
        url: `/api/user-management/v1/users/getOpcGroupList?countryCode=${payload}`,
        method: "POST",
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return [];
    }
  }
);
const buildUserDetailsRequest = (payload: any) => ({
  mstPartnerId: payload.mstPartnerId,
  mstUsrId: payload.mstUsrId,
  loginId: payload.loginId,
  usrNm: payload.usrNm,
  contactNo: payload.contactNo,
  title: payload.title,
  contactPerson: payload.contactPerson,
  mstGrp: payload.mstGrp.map((g: any) => {
    return {
      mstGrpId: g.mstGrpId,
      usrGrpNm: g.usrGrpNm,
      countryAccess: payload?.countryAccess,
      locationAccess: payload?.locationAccess,
    };
  }),
  status: payload?.mstUsrId === null || payload?.mstUsrId === undefined || payload?.mstUsrId === ''
    ? AccountStatus.PENDING_VERIFICATION
    : payload.status,
  countryShortCode: payload.countryShortCode,
  isRootUser: payload.isRootUser,
  partnerNm: payload?.partnerNm,
});

export const saveUserDetails = createAsyncThunk(
  "/saveUserDetails",
  async (payload: any) => {
    try {
      const isNewUser = payload?.mstUsrId === null || payload?.mstUsrId === undefined || payload?.mstUsrId === '';
      const response = await axiosInstance({
        url: `/api/user-management/v1/users/saveUserDetails`,
        method: "POST",
        data: buildUserDetailsRequest(payload),
      });

      const payloadResponse = response?.data ?? {};
      const responseCode = String(payloadResponse?.responseCode ?? '').toUpperCase();
      const responseMsg = payloadResponse?.responseMsg ?? payloadResponse?.message ?? 'User details saved successfully.';

      if (responseCode === 'SUCCESS') {
        return {
          ...payloadResponse,
          isNewUser,
          successMessage: isNewUser
            ? 'User added. A verification link has been sent to their email.'
            : responseMsg,
          responseCode,
          responseMsg,
        };
      }

      return {
        ...payloadResponse,
        isNewUser,
        responseCode,
        responseMsg,
        successMessage: responseMsg,
        error: true,
      };
    } catch (e) {
      const error = e as AxiosError<any>;
      const responseCode = String(error?.response?.data?.responseCode ?? '').toUpperCase();
      const responseMsg = error?.response?.data?.responseMsg ?? error?.response?.data?.message ?? error?.message ?? 'Please Try Again';
      console.error(error);

      return {
        responseCode,
        responseMsg,
        successMessage: responseMsg,
        error: true,
      };
    }
  }
);

export const addUserFromDashboard = createAsyncThunk(
  "/dashboard/add-user",
  async (payload: any) => {
    try {
      const isNewUser = payload?.mstUsrId === null || payload?.mstUsrId === undefined || payload?.mstUsrId === '';
      const response = await axiosInstance({
        url: `/api/user-management/v1/users/dashboard/add-user`,
        method: "POST",
        data: buildUserDetailsRequest(payload),
      });

      const payloadResponse = response?.data ?? {};
      const responseCode = String(payloadResponse?.responseCode ?? '').toUpperCase();
      const responseMsg = payloadResponse?.responseMsg ?? payloadResponse?.message ?? 'User added successfully.';

      if (responseCode === 'SUCCESS') {
        return {
          ...payloadResponse,
          isNewUser,
          successMessage: isNewUser
            ? 'User added. A verification link has been sent to their email.'
            : responseMsg,
          responseCode,
          responseMsg,
        };
      }

      return {
        ...payloadResponse,
        isNewUser,
        responseCode,
        responseMsg,
        successMessage: responseMsg,
        error: true,
      };
    } catch (e) {
      const error = e as AxiosError<any>;
      const responseCode = String(error?.response?.data?.responseCode ?? '').toUpperCase();
      const responseMsg = error?.response?.data?.responseMsg ?? error?.response?.data?.message ?? error?.message ?? 'Please Try Again';
      console.error(error);

      return {
        responseCode,
        responseMsg,
        successMessage: responseMsg,
        error: true,
      };
    }
  }
);

export const getGroupListRegistrationMaster = createAsyncThunk(
  "/getGroupList",
  async (payload: any) => {
    //  debugger
    try {
      const response = await axiosInstance({
        url: `/api/user-management/v1/users/getGroupList?countryCode=${payload}`,
        method: "POST",
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return [];
    }
  }
);

export const getGroupList = createAsyncThunk(
  "/getGroupList",
  async (payload: any) => {
    try {
      const response = await axiosInstance({
        url: `/api/user-management/v1/users/getGroupList?countryCode=${payload}`,
        method: "POST",
      });
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      console.error(error);

      return [];
    }
  }
);